import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { NewSalesComponent } from './pages/new-sales/new-sales.component';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { ActiveContractsComponent } from './pages/active-contracts/active-contracts.component';
import { PartnerSelectionComponent } from './pages/partner-selection/partner-selection.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'novas-vendas',
    component: NewSalesComponent
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },
  {
    path: 'contratos-ativos',
    component: ActiveContractsComponent
  },
  {
    path: 'selecionar-parceiro',
    component: PartnerSelectionComponent
  }
];
